import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {     
            mineReports:[],       
            reportCenterReports:[],
            reportFeeds:[],
            otherReports:[],
            upsertDefinition:null,
            uniqueAuthorChart:null,
            engagements:null,
            categoryRates:null,
            sentimentChart:null,
            socialMediaRates:null,
            interactionChart:null,
            talkRateChart:null,
            locationChart:null
        }
    },
    getters,
    actions,
    mutations
}